import { useState } from 'react';
import type { AgendyAisAgendaDto, AgendyAisAgendaSeznamDto } from '@gov-nx/api';
import {
	searchAgendasQuery,
	useAxiosInstance,
	usePoMutation,
	usePoQuery,
} from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';

export const useAgendaSearchAutocomplete = (order: 'nazev', start = 0) => {
	const [text, setText] = useState<Optional<string>>(undefined);
	const { axiosInstance } = useAxiosInstance();

	const { isLoading, isFetching, data } = usePoQuery<AgendyAisAgendaSeznamDto>({
		queryKey: ['agenda-autocomplete', order, start, text],
		queryFn: () =>
			searchAgendasQuery(axiosInstance, text as string, order, start),
		enabled: text ? text?.length > 2 : false,
		retry: 0,
		refetchOnWindowFocus: false,
	});

	const mutation = usePoMutation({
		mutationFn: (value: string) =>
			searchAgendasQuery(axiosInstance, value, order, start),
	});

	return {
		isLoading,
		isFetching,
		agendas: data?.seznam || [],
		setText,
		searchCallback: async (input: string): Promise<AgendyAisAgendaDto[]> => {
			const result = await mutation.mutateAsync(input);
			return result.seznam ?? [];
		},
	};
};
